import apiClient from './client';

export const chatbotAPI = {
  sendMessage: (message) => apiClient.post('/chatbot/chat/', { message }),
};